import {createAction} from 'redux-actions';

const PREFIX = 'CIRCLE_';

//sso login
export const signIn = createAction(`${PREFIX}SIGN_IN`);
export const signInSuccess = createAction(`${PREFIX}SIGN_IN_SUCCESS`, (payload) => payload);
export const signInFailure = createAction(`${PREFIX}SIGN_IN_FAILURE`, (payload) => payload);
